/* eslint-disable max-len */
import {ref} from 'vue';
export const SECRET_KEY = 'AZRGYAHA7272';

export let errorApi = false;
export const setErrorApi = () => (errorApi = true);

export const params = ref({});
export const loadStore = (store) => {
  params.value.userId =
    store.getters['auth/getImpersonateUser'] ?? store.getters['auth/getUserId'];
  params.value.unidadId = store.getters['auth/getUnidadId'];
};
export const setParams = (_userId, _unidadId) => {
  params.value.userId = _userId;
  params.value.unidadId = _unidadId;
};

export const path = `/`;
export const pathMaestras = '/Expedientes/';
export const pathWithParams = () => {
  return `/${params.value.userId}/${params.value.unidadId}/`;
};

export const checkAccessRoles = (store, listRoles) => {
  return store.getters['auth/getCompareRolesTextos'](
    store.state.enums,
    listRoles,
  );
};

export const valiteForm = (_listRequired, _data) => {
  const listError = {};

  _listRequired.forEach((clave) => {
    let valor = _data;
    const keys = clave.split('.');
    for (const key of keys) {
      if (valor[key] !== undefined) {
        valor = valor[key];
      } else {
        valor = undefined;
        break;
      }
    }

    if (valor === null || valor === '' || valor === undefined || valor.length === 0) {
      listError[clave] = true;
    }
  });
  const validateError = JSON.stringify(listError) === '{}';
  return [listError, validateError];
};

export const apiVersion = 'api-version=1.0';
export const literales = {titleFilter: 'Filtros'};
/* TimeOut por defecto de todos los endpoint */
export const DEFAULT_TIMEOUT = STTEDRA_DEFAULT_TIMEOUT;

/* Datos de sigex */
export const capasInicioLocalSigex = 'PK_Cat.IDEE-Carreteras.PNOA_MA';
export const capasEjes = 'Ejes_inventario.RedEstatal.PNOA_MA';
export const capasCroquis = 'layers_defaultPNOA_M';
